/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetMeCalendarConnectionsGoogleAuthorizeUrlParams,
  MicrosoftAspNetCoreMvcProblemDetails,
  TrainWithMeModulesTrainingDtosRequestsPostGoogleCalendarConnectionRequest,
  TrainWithMeModulesTrainingDtosResponsesGoogleCalendarAuthorizationResponse,
  TrainWithMeModulesTrainingDtosResponsesGoogleCalendarConnectionResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const deleteMeCalendarConnectionsGoogle = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesGoogleCalendarConnectionResponse>(
      {url: `/me/calendar-connections/google`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteMeCalendarConnectionsGoogleMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMeCalendarConnectionsGoogle>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMeCalendarConnectionsGoogle>>, TError,void, TContext> => {

const mutationKey = ['deleteMeCalendarConnectionsGoogle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMeCalendarConnectionsGoogle>>, void> = () => {


          return  deleteMeCalendarConnectionsGoogle(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMeCalendarConnectionsGoogleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMeCalendarConnectionsGoogle>>>

    export type DeleteMeCalendarConnectionsGoogleMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const useDeleteMeCalendarConnectionsGoogle = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMeCalendarConnectionsGoogle>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMeCalendarConnectionsGoogle>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteMeCalendarConnectionsGoogleMutationOptions(options), queryClient);
    }
    export const getMeCalendarConnectionsGoogle = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesGoogleCalendarConnectionResponse>(
      {url: `/me/calendar-connections/google`, method: 'GET', signal
    },
      options);
    }




export const getGetMeCalendarConnectionsGoogleQueryKey = () => {
    return [
    `/me/calendar-connections/google`
    ] as const;
    }


export const getGetMeCalendarConnectionsGoogleQueryOptions = <TData = Awaited<ReturnType<typeof getMeCalendarConnectionsGoogle>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeCalendarConnectionsGoogle>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeCalendarConnectionsGoogleQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeCalendarConnectionsGoogle>>> = ({ signal }) => getMeCalendarConnectionsGoogle(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMeCalendarConnectionsGoogle>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeCalendarConnectionsGoogleQueryResult = NonNullable<Awaited<ReturnType<typeof getMeCalendarConnectionsGoogle>>>
export type GetMeCalendarConnectionsGoogleQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetMeCalendarConnectionsGoogle<TData = Awaited<ReturnType<typeof getMeCalendarConnectionsGoogle>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeCalendarConnectionsGoogle>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeCalendarConnectionsGoogle>>,
          TError,
          Awaited<ReturnType<typeof getMeCalendarConnectionsGoogle>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeCalendarConnectionsGoogle<TData = Awaited<ReturnType<typeof getMeCalendarConnectionsGoogle>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeCalendarConnectionsGoogle>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeCalendarConnectionsGoogle>>,
          TError,
          Awaited<ReturnType<typeof getMeCalendarConnectionsGoogle>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeCalendarConnectionsGoogle<TData = Awaited<ReturnType<typeof getMeCalendarConnectionsGoogle>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeCalendarConnectionsGoogle>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMeCalendarConnectionsGoogle<TData = Awaited<ReturnType<typeof getMeCalendarConnectionsGoogle>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeCalendarConnectionsGoogle>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeCalendarConnectionsGoogleQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postMeCalendarConnectionsGoogle = (
    trainWithMeModulesTrainingDtosRequestsPostGoogleCalendarConnectionRequest?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostGoogleCalendarConnectionRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesGoogleCalendarConnectionResponse>(
      {url: `/me/calendar-connections/google`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesTrainingDtosRequestsPostGoogleCalendarConnectionRequest, signal
    },
      options);
    }




export const getPostMeCalendarConnectionsGoogleMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMeCalendarConnectionsGoogle>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostGoogleCalendarConnectionRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMeCalendarConnectionsGoogle>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostGoogleCalendarConnectionRequest>}, TContext> => {

const mutationKey = ['postMeCalendarConnectionsGoogle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMeCalendarConnectionsGoogle>>, {data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostGoogleCalendarConnectionRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postMeCalendarConnectionsGoogle(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostMeCalendarConnectionsGoogleMutationResult = NonNullable<Awaited<ReturnType<typeof postMeCalendarConnectionsGoogle>>>
    export type PostMeCalendarConnectionsGoogleMutationBody = BodyType<TrainWithMeModulesTrainingDtosRequestsPostGoogleCalendarConnectionRequest> | undefined
    export type PostMeCalendarConnectionsGoogleMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostMeCalendarConnectionsGoogle = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMeCalendarConnectionsGoogle>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostGoogleCalendarConnectionRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMeCalendarConnectionsGoogle>>,
        TError,
        {data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostGoogleCalendarConnectionRequest>},
        TContext
      > => {
      return useMutation(getPostMeCalendarConnectionsGoogleMutationOptions(options), queryClient);
    }
    export const getMeCalendarConnectionsGoogleAuthorizeUrl = (
    params: GetMeCalendarConnectionsGoogleAuthorizeUrlParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesGoogleCalendarAuthorizationResponse>(
      {url: `/me/calendar-connections/google/authorize-url`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetMeCalendarConnectionsGoogleAuthorizeUrlQueryKey = (params?: GetMeCalendarConnectionsGoogleAuthorizeUrlParams,) => {
    return [
    `/me/calendar-connections/google/authorize-url`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMeCalendarConnectionsGoogleAuthorizeUrlQueryOptions = <TData = Awaited<ReturnType<typeof getMeCalendarConnectionsGoogleAuthorizeUrl>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(params: GetMeCalendarConnectionsGoogleAuthorizeUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeCalendarConnectionsGoogleAuthorizeUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeCalendarConnectionsGoogleAuthorizeUrlQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeCalendarConnectionsGoogleAuthorizeUrl>>> = ({ signal }) => getMeCalendarConnectionsGoogleAuthorizeUrl(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMeCalendarConnectionsGoogleAuthorizeUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeCalendarConnectionsGoogleAuthorizeUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getMeCalendarConnectionsGoogleAuthorizeUrl>>>
export type GetMeCalendarConnectionsGoogleAuthorizeUrlQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetMeCalendarConnectionsGoogleAuthorizeUrl<TData = Awaited<ReturnType<typeof getMeCalendarConnectionsGoogleAuthorizeUrl>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params: GetMeCalendarConnectionsGoogleAuthorizeUrlParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeCalendarConnectionsGoogleAuthorizeUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeCalendarConnectionsGoogleAuthorizeUrl>>,
          TError,
          Awaited<ReturnType<typeof getMeCalendarConnectionsGoogleAuthorizeUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeCalendarConnectionsGoogleAuthorizeUrl<TData = Awaited<ReturnType<typeof getMeCalendarConnectionsGoogleAuthorizeUrl>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params: GetMeCalendarConnectionsGoogleAuthorizeUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeCalendarConnectionsGoogleAuthorizeUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeCalendarConnectionsGoogleAuthorizeUrl>>,
          TError,
          Awaited<ReturnType<typeof getMeCalendarConnectionsGoogleAuthorizeUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeCalendarConnectionsGoogleAuthorizeUrl<TData = Awaited<ReturnType<typeof getMeCalendarConnectionsGoogleAuthorizeUrl>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params: GetMeCalendarConnectionsGoogleAuthorizeUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeCalendarConnectionsGoogleAuthorizeUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMeCalendarConnectionsGoogleAuthorizeUrl<TData = Awaited<ReturnType<typeof getMeCalendarConnectionsGoogleAuthorizeUrl>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params: GetMeCalendarConnectionsGoogleAuthorizeUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeCalendarConnectionsGoogleAuthorizeUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeCalendarConnectionsGoogleAuthorizeUrlQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postMeCalendarConnectionsGooglePromptAnswer = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesGoogleCalendarConnectionResponse>(
      {url: `/me/calendar-connections/google/prompt-answer`, method: 'POST', signal
    },
      options);
    }




export const getPostMeCalendarConnectionsGooglePromptAnswerMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMeCalendarConnectionsGooglePromptAnswer>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMeCalendarConnectionsGooglePromptAnswer>>, TError,void, TContext> => {

const mutationKey = ['postMeCalendarConnectionsGooglePromptAnswer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMeCalendarConnectionsGooglePromptAnswer>>, void> = () => {


          return  postMeCalendarConnectionsGooglePromptAnswer(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostMeCalendarConnectionsGooglePromptAnswerMutationResult = NonNullable<Awaited<ReturnType<typeof postMeCalendarConnectionsGooglePromptAnswer>>>

    export type PostMeCalendarConnectionsGooglePromptAnswerMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostMeCalendarConnectionsGooglePromptAnswer = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMeCalendarConnectionsGooglePromptAnswer>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMeCalendarConnectionsGooglePromptAnswer>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPostMeCalendarConnectionsGooglePromptAnswerMutationOptions(options), queryClient);
    }
